import {
  Bookmark,
  BrainCircuit,
  CheckCircle2,
  FileText,
  StickyNote,
} from "lucide-react"
import {
  STUDENT_BASE_PATH,
  STUDENT_BOOKMARKS_PATH,
  STUDENT_NOTES_PATH,
  STUDENT_PRACTICE_PAPERS_PATH,
  STUDENT_QUESTIONS_PATH,
} from "../../../../component/student/config/studentNavItems"
import type { DashboardQuickLink } from "../types"

export const DASHBOARD_QUICK_LINKS: DashboardQuickLink[] = [
  {
    label: "Question Library",
    path: STUDENT_QUESTIONS_PATH,
    icon: CheckCircle2,
    tone: "primary",
  },
  {
    label: "Practice Papers",
    path: STUDENT_PRACTICE_PAPERS_PATH,
    icon: FileText,
    tone: "blue",
  },
  {
    label: "AI Assessor",
    path: `${STUDENT_BASE_PATH}/ai-assessor`,
    icon: BrainCircuit,
    tone: "violet",
  },
  {
    label: "Bookmarks",
    path: STUDENT_BOOKMARKS_PATH,
    icon: Bookmark,
    tone: "amber",
  },
  {
    label: "My Notes",
    path: STUDENT_NOTES_PATH,
    icon: StickyNote,
    tone: "emerald",
  },
]
